export const employmentLabel = (t: string) =>
  ({ full_time: "Full Time", part_time: "Part Time", contract: "Contract", internship: "Internship", "Full-time": "Full Time", "Part-time": "Part Time", Contract: "Contract", Internship: "Internship" })[t] || t;

export const workplaceLabel = (t: string) =>
  ({ remote: "Remote", on_site: "On Site", hybrid: "Hybrid", Remote: "Remote", "On-site": "On Site", Hybrid: "Hybrid" })[t] || t;

export const seniorityLabel = (l: string) =>
  ({ entry: "Entry Level", entry_level: "Entry Level", mid: "Mid Level", mid_level: "Mid Level", senior: "Senior Level", senior_level: "Senior Level", lead: "Lead", director: "Director", executive: "Executive", Entry: "Entry Level", Mid: "Mid Level", Senior: "Senior Level", Lead: "Lead", Director: "Director", Executive: "Executive" })[l] || l;

export const stripMarkdown = (md: string): string =>
  md
    .replace(/#{1,6}\s+/g, "")
    .replace(/(\*{1,3}|_{1,3})(.*?)\1/g, "$2")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/`{1,3}[^`]*`{1,3}/g, "")
    .replace(/^\s*[-*+]\s+/gm, "")
    .replace(/^\s*>\s+/gm, "")
    .replace(/\n{2,}/g, " ")
    .replace(/\n/g, " ")
    .trim();

export const monogram = (title: string): string => {
  const words = title.replace(/[^a-zA-Z0-9 ]/g, "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "AI";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const isRecent = (createdAt: string): boolean => {
  const t = new Date(createdAt).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t <= 7 * 86400000;
};
